import { STATES } from "./constants";
import {
  Description,
  Image,
  Logo,
  MapWrapper,
  MarcosImage,
  StateContainer,
  StatesContainer,
  Title,
  TitleMapWrapper,
  Wrapper,
  MobileMarcosImage,
  MobileLogo
} from "./styles";
import { MdLocationOn } from "react-icons/md";
import mapImg from "../../../../assets/pages/NewHome/MapSection/mapmap-solo.png";
import marcosImg from "../../../../assets/pages/NewHome/MapSection/marcos-lessa.png";
import marcosMobileImg from "../../../../assets/pages/NewHome/MapSection/marcos-lessaa.png";
import React from "react";

function MapSection() {
  return (
    <Wrapper>
      <Logo />
      <MobileLogo />
      <TitleMapWrapper>
        <Title>Criando conexões que movem o Brasil.</Title>
        <Description>
          De norte a sul, já estamos presentes - e vem muito mais por aí!
        </Description>
        <StatesContainer>
          {STATES.map((state) => (
            <StateContainer key={state}>
              <MdLocationOn /> {state}
            </StateContainer>
          ))}
        </StatesContainer>
      </TitleMapWrapper>

      <MapWrapper>
        <Image src={mapImg} alt="Mapa do Brasil mostrando a abrangência da 7cantos" />
      </MapWrapper>

      <MarcosImage src={marcosImg} alt="Marcos Lessa, fundador da 7cantos" />
      <MobileMarcosImage src={marcosMobileImg} alt="Marcos Lessa, fundador da 7cantos" />
    </Wrapper>
  );
}

export default MapSection;